import z from 'zod'

import { StrapiContentModel } from '@/src/domains/strapi/constants'
import { getCacheTag } from '@/src/domains/strapi/services/getCacheTag'
import type { StrapiQueryParams } from '@/src/domains/strapi/types'
import { fetchStrapi } from '@/src/domains/strapi/utils/fetchStrapi'
import { fetchStrapiLocalizedSlugs } from '@/src/domains/strapi/utils/fetchStrapiLocalizedSlugs'

export const getStrapiCounsellingPageSlugTag = (slug: string) => getCacheTag(slug, StrapiContentModel.COUNSELLING_PAGE)

export async function fetchStrapiCounsellingPageBySlug<Schema extends z.ZodObject<z.ZodRawShape>>({
  slug,
  query,
  schema,
}: {
  slug: string
  schema: Schema
  query?: StrapiQueryParams
}) {
  const data = await fetchStrapi({
    contentType: 'counselling-pages',
    query: {
      ...query,
      filters: {
        ...query?.filters,
        slug,
      },
    },
    schema: z.array(schema),
    cache: {
      tags: [getStrapiCounsellingPageSlugTag(slug)],
    },
  })

  return data.at(0)
}

export async function fetchStrapiCounsellingPageLocalizedSlugs(slug: string) {
  return await fetchStrapiLocalizedSlugs({
    contentType: 'counselling-pages',
    slug,
    cache: {
      tags: [getStrapiCounsellingPageSlugTag(slug)],
    },
  })
}
